/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from "moment";
import { isProcessData } from "./tableUtils";

const getDateBucketRange = (
  value: any,
  bucketType: string
): { __bucketRange: true; min: string; max: string } | null => {
  if (value == null) return null;
  const date = moment.utc(value);
  if (!date.isValid()) return null;

  let min: moment.Moment;
  let max: moment.Moment;

  switch (bucketType) {
    case "YEAR":
      min = date.clone().startOf("year");
      max = date.clone().endOf("year");
      break;
    case "MONTH":
      min = date.clone().startOf("month");
      max = date.clone().endOf("month");
      break;
    case "WEEK":
      min = date.clone().startOf("isoWeek");
      max = date.clone().endOf("isoWeek");
      break;
    case "DAY":
      min = date.clone().startOf("day");
      max = date.clone().endOf("day");
      break;
    default:
      return null;
  }

  return { __bucketRange: true, min: min.toISOString(), max: max.toISOString() };
};

export const getCellFilter = (column: any, data: any): any[] => {
  let cellValue: any[] = [];
  if (isProcessData(column.key)) {
    cellValue = [data[column.key + "_state"]];
  } else if (column.isGrouped && column.aliasName) {
    const supportedGroupType = column.tableDescriptor?.supportedGroupType;
    if (supportedGroupType === "NUMERIC_BUCKET") {
      const bucketLow = data[column.aliasName + ".bucketLow"];
      const bucketHigh = data[column.aliasName + ".bucketHigh"];
      if (bucketLow != null && bucketHigh != null) {
        return [{ __bucketRange: true, min: bucketLow, max: bucketHigh }];
      }
      // Edge cases: "< X" (only bucketHigh) or ">= X" (only bucketLow)
      if (bucketLow != null) {
        return [{ __bucketRange: true, min: bucketLow, max: null }];
      }
      if (bucketHigh != null) {
        return [{ __bucketRange: true, min: null, max: bucketHigh }];
      }
      return [];
    } else if (supportedGroupType === "DATE_BUCKET") {
      const bucketType = column.bucketType;
      const groupValue = data[column.aliasName];
      if (bucketType && groupValue != null) {
        const range = getDateBucketRange(groupValue, bucketType);
        if (range) return [range];
      }
      return [];
    } else if (column.cellFilterValue) {
      cellValue = column.cellFilterValue(data, column);
    } else {
      cellValue = [data[column.aliasName]];
    }
  } else if (column.cellFilterValue) {
    cellValue = column.cellFilterValue(data, column);
  } else {
    cellValue = [data[column.key]];
  }

  cellValue = (cellValue || []) as any[];
  return cellValue.filter(
    (item: any) => item != null && item != undefined && item !== ""
  );
};

export const getCellCopyData = (column: any, data: any): any[] => {
  let cellValue: any[] = [];
  if (column.cellCopyData) {
    cellValue = column.cellCopyData(data, column);
  } else {
    cellValue = [data[column.key]];
  }

  cellValue = (cellValue || []) as any[];
  return cellValue.filter(
    (item: any) => item != null && item != undefined && item !== ""
  );
};
